import { request } from '@/utils/request/request';

export function getHostInfo() {
  return request({
    url: 'api/monitor/v1/GetHostInfo',
    method: 'GET',
  });
}
export function getDataRang(params) {
  return request({
    url: 'api/monitor/v1/GetDataRang',
    method: 'GET',
    params,
  });
}
